import {
  BLOG_CATEGORY_PAGE,
  BLOG_HOME_PAGE,
  BLOG_PAGE,
  HOME_PAGE,
  FACILITY_PAGE,
  MISC_PAGE,
  FACILITIES_LIST_PAGE,
  PRIVACY_PAGE,
  TERMS_PAGE,
  PAY_ONLINE_PAGE,
  PAGE_LAYOUT,
} from 'shared/pageTypes';
import { FIXED_TOP, PREHEADER, HEADER, BODY, FOOTER, FIXED_BOTTOM } from './sectionTypes';
class PageTypeSection {
  /**
   * @param {Object=} config - class configuration
   * @param {integer=null} config.limit - the number of sections allowed in this section type
   * @param {Object=} config.weights - the weights of sections in this page type (e.g., `{ SimpleHero: 99 }`)
   * @param {integer=0} config.defaultWeight - the weight of a section without an explicitly specified weight
   * @param {string[]=} config.allow - the sections allowed in this section type (if defined, a section *must* appear in this list to be allowed)
   * @param {string[]=} config.disallow - the sections not allowed in this section type
   */
  constructor({
    limit, weights, defaultWeight, allow, disallow,
  }) {
    this.limit = limit || null;
    this.defaultWeight = defaultWeight || 0;
    this.weights = weights || {};
    this.allow = allow;
    this.disallow = disallow;
  }
  /**
   * @param {string} sectionType - the section to look up
   * @returns {boolean} whether or not the given section is allowed in this section type
   */
  accepts(sectionType) {
    if (this.allow && this.allow.indexOf(sectionType) === -1) {
      return false;
    } if (this.disallow && this.disallow.indexOf(sectionType) !== -1) {
      return false;
    }
    return true;
  }
  /**
   * @param {string} sectionType - the section to look up
   * @returns {number} the weight of the given section
   */
  weight(sectionType) {
    return this.weights[sectionType] || this.defaultWeight;
  }
}
export default {
  [HOME_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      weights: {
        SimpleHero: 99,
      },
      // disallow: [
      // 'ContactFacility',
      // 'FacilitiesList',
      // 'FacilityUnits',
      // 'PayOnline',
      // 'Privacy',
      // 'TermsAndConditions',
      // 'TermsAndConditions',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [BLOG_CATEGORY_PAGE]: {
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [BLOG_HOME_PAGE]: {
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [BLOG_PAGE]: {
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [FACILITY_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // 'FacilitiesList',
      // 'PayOnline',
      // 'Privacy',
      // 'TermsAndConditions',
      // 'TermsAndConditions',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [MISC_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // 'ContactFacility',
      // 'FacilitiesList',
      // 'FacilityUnits',
      // 'PayOnline',
      // 'Privacy',
      // 'TermsAndConditions',
      // 'TermsAndConditions',
      // 'UnitSizes',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [PRIVACY_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // limit: 1,
      // allow: [
      //   'Privacy',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [TERMS_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // limit: 1,
      // allow: [
      //   'TermsAndConditions',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [PAY_ONLINE_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // limit: 1,
      // allow: [
      //   'Header',
      //   'HeaderTwoColumn',
      //   'PayOnline',
      //   'SimpleHero',
      //   'StackingThreeColumn',
      //   'ThreeColumn',
      //   'TwoColumn',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [FACILITIES_LIST_PAGE]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      // disallow: [
      // 'AboutWithCoupon',
      // 'FacilityUnits',
      // 'PayOnline',
      // 'Privacy',
      // 'Reviews',
      // 'TermsAndConditions',
      // 'UnitSizes',
      // ],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
  [PAGE_LAYOUT]: {
    [FIXED_TOP]: new PageTypeSection({
      limit: 1,
    }),
    [PREHEADER]: new PageTypeSection({
      limit: 1,
    }),
    [HEADER]: new PageTypeSection({
      limit: 2,
    }),
    [BODY]: new PageTypeSection({
      limit: 1,
      allow: ['ChildBlock'],
    }),
    [FOOTER]: new PageTypeSection({
      limit: 1,
    }),
    [FIXED_BOTTOM]: new PageTypeSection({
      limit: 1,
    }),
  },
};
